import { PartType, UploadInformationType } from "../utils/component/upload/uploadItem/uploadItem.interface";

export interface UserType {
    contact_id?: number; // Contact
    access?: ResourceAccessEnum; // Contact
    id: number;
    phone: string;
    name: string;
    picture_url: string;
    channel_name: string;
    searchable: boolean;
    orgs: Array<Organization>;
    prefix: string;
}

export interface CaptchaType {
    id?: string;
    image?: string;
    provider?: string;
    value?: string;
}

export interface FolderMetaDataType {
    id: number;
    path: string;
    ids_path: string;
}

export interface UploadLinkUrl {
    id: number;
    name: string;
    url: string;
    size: number;
    created_at: string;
    updated_at: string;
    status: LinkUploadStatus;
    user: number;
    obj: number;
    parent: number;
}

export interface ResourceType {
    id: number;
    name: string;
    type?: string | null;
    download_url: string;
    folder_metadata: FolderMetaDataType | null;
    key: string;
    size: number;
    is_complete: boolean;
    level: number;
    user: UserType;
    has_cover?: boolean;
    last_modified: number;
    created_at: number;
    is_favorite: boolean;
    has_link: boolean;
    is_shared: boolean;
    from_link: boolean;
    parent?: number;
    shareData?: { id: number; parent: number; access: ResourceAccessEnum };
    user_access?: { user: UserType; access: ResourceAccessEnum }[];
    obj_hash?: string;
    parent_hash?: string;
    linkUploadStatus?: LinkUploadStatus;
    detail?: string;
    is_trash?: boolean;
    version_group?: string;
    is_current_version?: boolean;
    version?: number;
    keep_forever?: boolean;
    last_opened?: number;
    public_links?: PublicLink[];
    malware_risk?: number | null;
    antivirus_status?: any;
    cp_approved?: null | boolean;
}

export enum CompleteFileQueueStatus {
    QUEUE,
    PROGRESS
}

export interface CompleteFileQueueType {
    id: string;
    uploadInformation: UploadInformationType;
    uploadedFile: FileType;
    status: CompleteFileQueueStatus;
    parts: PartType[];
}

export interface PublicLink {
    id: number;
    link: string;
    downloads: number;
    duration: number | null;
    expiration_count: number | null;
    created_at: string;
    updated_at: string;
}

export interface QuotaType {
    plan_exp_time: number;
    gift_exp_time: number;
    used: number;
    total_plan: number;
    total_gift: number;
}

export interface CurrentPlanType {
    plan?: PlanType;
    active_exp?: number;
    extra_exp?: number;
    locked_exp?: number;
    purchased_at?: number;
    server_time?: number;
    is_active?: boolean;
    remainingTime?: number;
    status?: CurrentPlanStatus;
}

export interface newPlanType {
    duration: number;
    id: number;
    price: number;
    volume: number;
    label: string;
}

export interface listPurchaseType {
    created_at: number;
    expires_at: number;
    id: number;
    is_active: boolean;
    rrn: string;
    status: number;
    plan: newPlanType;
}

export interface activePurchasesType {
    userPlanStatus: UserPlanStatus;
    serverTime: number;
    purchasesPlans: listPurchaseType[];
}

export interface purchasePlanType {
    created_at: number;
    id: number;
    plan: planResourceType;
    status: PlanStatus;
    rnn: string;
    planStatusDuration: CurrentPlanStatus;
}

export interface PlanType {
    id: number;
    volume: number;
    price: number;
    label: string;
    duration: number;
    discount: number;
}

export interface FileType {
    id: string;
    parentId?: number;
    folderName?: string;
    file: File;
    name: string;
    status: FileUploadStatus;
    overwrite: boolean;
    hash?: string;
    versionGroup?: string;
    versionByEdit?: boolean;
    failStatus?: number;
}

export interface FolderUploadStructureType {
    name: string;
    children: FolderUploadStructureType[];
    file?: File;
    parent?: number;
    hash?: string;
}

export interface planResourceType {
    id: number;
    label: string;
    volume: number;
    price: number;
    duration?: number;
    discount: number;
}

export interface historyPlanResourceType {
    id: number;
    plan: planResourceType;
    created_at: number;
    status: PlanStatus;
    is_crm_active: boolean;
    is_active: boolean;
}

export enum PlanStatus {
    NotSuccess = -1,
    Unknown,
    Success
}

export enum CurrentPlanStatus {
    active = 1,
    expire,
    locked,
    out
}

export enum UserPlanStatus {
    NORMAL,
    DANGER
}

export enum FileUploadStatus {
    PROGRESS,
    PENDING,
    QUEUE,
    DONE,
    FAILED,
    PAUSED
}

export enum ResourceAccessEnum {
    READ,
    WRITE
}

export enum FileManagerModeEnum {
    MAIN,
    TRASH,
    FAVORITE,
    SHARED,
    DASHBOARD,
    PUBLIC,
    DUPLICATED_LIST
}

export enum LinkUploadStatus {
    NEW = "New",
    QUEUED = "Queued",
    CONSUMING = "Consuming",
    FAILED = "Failed",
    DONE = "Done"
}

export enum SizeRangeEnum {
    B = "بایت",
    KB = "کیلوبایت",
    MB = "مگابایت",
    GB = "گیگابایت",
    TB = "ترابایت"
}

export interface NotificationType {
    id: number;
    message: string;
    created_at: number;
    is_read: IsReadTypeEnum;
    type: NotificationTypes;
    data: {
        key: string;
        value: string;
    }[];
}

export enum IsReadTypeEnum {
    READ,
    UNREAD
}

export enum NotificationTypes {
    USER_LOGIN = 0,
    PLAN = 1,
    SHARED_FILE = 2,
    LINK_UPLOUD = 3,
    LINK_UPLOUD_IN_SHARED_FOLDER = 4
}

export enum OnBoarding {
    memory,
    newFolder,
    uploadLink,
    contacts,
    report,
    completed
}
export interface musicItemType {
    id: number;
    name: string;
    artist: string;
    cover: string;
    url: string;
    text: string;
    shareUrl: string;
    timestamp: number;
}

export interface IconProps {
    className?: string;
    onClick?: () => void;
}

export interface ListPurchase {
    id: number;
    status: PlanStatus;
    plan: PlanType;
    rrn: string;
    is_active: boolean;
    created_at: number;
    expires_at: number;
    isActive?: CurrentPlanStatus;
}

export enum ListSortStatus {
    ENCREAS_VOLUM = "size",
    DECREASE_VOLUM = "-size",
    ENCREAS_NAME = "name",
    DECREASE_NAME = "-name",
    ENCREAS_LAST_MODIFIED = "last_modified",
    DECREASE_LAST_MODIFIED = "-last_modified",
    ENCREAS_LAST_OPENED = "last_opened",
    DECREASE_LAST_OPENED = "-last_opened",
    ENCREAS_CREATED_AT = "created_at",
    DECREASE_CREATED_AT = "-created_at"
}

export type Organization = {
    id: number;
    name: string;
    total_quota: number;
    used_quota: number;
    quota_exp: number;
    managers: Array<ManagetUset>;
};

export type ManagetUset = {
    id: number;
    name: string;
    phone: string;
    picture_url: string;
    prefix: string;
};

export type OrgUser = {
    gift_label: string;
    gift_volume: number;
    org_id: number;
    gift_exp_time: number;
    auto_renewal: boolean;
};

export type ContactType = {
    contact_id: number;
    name: string;
    phone: string;
    picture_url: string;
    prefix: string;
};

export enum HistorySearchEnum {
    MINE = "MINE",
    SHARED = "SHARED"
}

export type HistorySearchType = {
    user: number;
    type: HistorySearchEnum;
    content: string;
    created_at: number;
    id: string;
};
